import { render, staticRenderFns } from "./ModalSelectEvent.vue?vue&type=template&id=65f13ac8&scoped=true&"
import script from "./ModalSelectEvent.vue?vue&type=script&lang=ts&"
export * from "./ModalSelectEvent.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSelectEvent.vue?vue&type=style&index=0&id=65f13ac8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f13ac8",
  null
  
)

export default component.exports